import { isNil, omit, omitBy, mapValues } from 'lodash';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

export const useMotionParams = () => {
    const prompt = useFormFieldValue({ field: 'motionParams.textPrompt' });
    const subjectMovement = useFormFieldValue({ field: 'motionParams.subjectMovement' });
    const cameraMovement = useFormFieldValue({ field: 'motionParams.cameraMovement' });

    const motionFormFields = {
        prompt,
        subjectMovement,
        cameraMovement,
    };

    const motionFormFieldsValues = mapValues(motionFormFields, field => field.value);
    const motionParams = omitBy(motionFormFieldsValues, value => isNil(value) || value === '');
    const tagListMotionParams = omit(motionParams, 'prompt');

    const clearMotionParamsFormFields = () => {
        Object.values(motionFormFields).forEach(({ onChange }) => onChange(null));
    };

    const clearMotionParamsFormField = field => {
        motionFormFields[field].onChange(null);
    };

    return {
        motionParams,
        tagListMotionParams,
        clearMotionParamsFormFields,
        clearMotionParamsFormField,
    };
};
